// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.van-form-offset .van-cell[data-v-4c90feef] {\n  font-size: 16px;\n  line-height: 32px;\n}\n.van-form-offset .van-field__button .van-button[data-v-4c90feef] {\n  vertical-align: bottom;\n}\n", ""]);
// Exports
module.exports = exports;
